const camelToNormalCase = str =>
	str
		.replace(/([A-Z])/g, ' $1')
		.toLowerCase()
		.replace(/^./, str => str.toUpperCase())
		.trim();

export default camelToNormalCase;
